<template>
  <ItemsView storeModule="productoptions"
    @remove="getProducts"
    width="fill"
    :headers="headers"
    titleSingle='Option'
    titleMultiple="Options">
    <template #itemForm="{ item }">

      <v-text-field label="Titel"
        v-model="item.title"
        :rules="[v => (v != null && v !== '') || 'Cannot be empty']">
      </v-text-field>
      <v-row>
        <v-col>
          <v-text-field label="Min value"
            v-model="item.min_count">
          </v-text-field>
        </v-col>
        <v-col>
          <v-text-field label="Max value"
            v-model="item.max_count">
          </v-text-field>
        </v-col>
        <v-col>
          <v-switch label="Use checkboxes" v-model="item.use_checkbox"></v-switch>   
        </v-col>
      </v-row>
      
      <div class="text-h6">Options
        <v-btn depressed
          fab
          x-small
          color="primary"
          class="ml-2"
          dark
          @click="showEditDialog({ creating: true })">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="editDialog"
        width="500">
        <ItemForm :creating="editItem.creating"
          @submit="addOption(editItem, item)"
          @remove="removeOption(editItem, item)"
          :item="editItem"
          @cancel="editDialog = false">
          <v-text-field label="label"
            :rules="[v => (v != null && v !== '') || 'Cannot be empty']"
            v-model="editItem.title"></v-text-field>
        </ItemForm>
      </v-dialog>
      <ItemsTable :items="item.options"
        :headers="headers"
        @reorder="reorder($event, item)"
        @click:row="showEditDialog($event, item)">
      </ItemsTable>
    </template>
  </ItemsView>
</template>
<script>
import { ItemsView, ItemsTable, ItemForm } from 'dync-baseitem'
import { uuidv4 } from '@dynapp/wc-api-generic'
export default {
  data() {
    return {
      item: {},
      addItem: {
        title: ''
      },
      editItem: {},
      editFields: [
        {
          type: 'text',
          id: 'title',
          props: {
            label: 'Title'
          }
        }
      ],
      addDialog: false,
      editDialog: false,
      headers: [{
        text: 'Titel',
        value: 'title'
      }]
    }
  },
  methods: {
    addOption(value, item) {
      if (!item.options) {
        this.$set(item, 'options', [])
      }
      if (item.options.indexOf(value) == -1) {
        item.options.push({ title: value.title, id: uuidv4()})
      }
      this.editDialog = false
    },
    removeOption(value, item) {
      if (!item.options || value.creating) {
        return
      }
      var index = item.options.indexOf(value)
      console.log(index);
      item.options.splice(index, 1)

      this.editDialog = false
    },
    saveItem(item) {
      console.log(item);
    },
    showEditDialog(editItem) {
      this.editItem = editItem
      this.editDialog = true
    },
    reorder(value, item){
      item.options = value
    },
    getProducts(){
      this.$store.dispatch('products/fetchItems');
    }
  },
  components: {
    ItemsView,
    ItemsTable,
    ItemForm
  }
} 
</script>